import React, { useMemo } from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { useSiteContent, sectionField } from "../../hooks/useSiteContent";

const CounterOne = () => {
    const { content } = useSiteContent("home");
    const { ref, inView } = useInView({ triggerOnce: true });

    const counters = useMemo(() => {
        const list = [];
        for (let i = 1; i <= 4; i += 1) {
            const value = parseFloat(sectionField(content, "counters", `${i}_value`, String([12, 97, 8, 19][i - 1])));
            list.push({
                value: Number.isFinite(value) ? value : 0,
                suffix: sectionField(content, "counters", `${i}_suffix`, ["", "%", "k", "k"][i - 1]),
                title: sectionField(content, "counters", `${i}_label`, ["Years Experience", "Retention Rate", "Tour Completed", "Happy Travellers"][i - 1]),
            });
        }
        return list;
    }, [content]);

    return (
        <div className="counter-area space" ref={ref}>
            <div className="container shape-mockup-wrap">
                <div className="row">
                    {counters.map((counter, index) => (
                        <div key={index} className="col-sm-6 col-xl-3 counter-card-wrap">
                            <div className="counter-card">
                                <div className="counter-shape"><span></span></div>
                                <div className="media-body">
                                    <h3 className="box-number">
                                        {inView && (
                                            <CountUp
                                                start={0}
                                                end={counter.value}
                                                duration={2}
                                                delay={0}
                                            />
                                        )}
                                        {counter.suffix}
                                    </h3>
                                    <h6 className="counter-title">{counter.title}</h6>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CounterOne;
